import React from "react"

import "./css/ContentDiv.min.css"
const ContentDiv = props => <div className="content" children={props.children} />

export default ContentDiv
